import { REMOVE_FROM_USER_CART , ADD_TO_USER_CART, RECEIVE_CART , RESET_CART , REMOVE_PRODUCT_FROM_USER_CART} from "../contents/actionTypes";


const cart = (state = [] , action) => {

    switch (action.type)
    {

        case RESET_CART:
            return []

        case RECEIVE_CART:
            return state

        case ADD_TO_USER_CART:
        {
            let { productId } = action
            let product = state[productId]

            if (product === undefined)
                state[productId] = 1
            else
                state[productId] = state[productId] + 1
            return state
        }


        case REMOVE_FROM_USER_CART:
        {
            let { productId } = action
            let product = state[productId]

            if (product !== undefined) {

                if (state[productId] - 1 === 0)
                    delete  state[productId]
                else
                    state[productId] = state[productId] - 1
            }

            return state
        }

        case REMOVE_PRODUCT_FROM_USER_CART:
        {
            let { productId } = action
            let product = state[productId]

            if (product !== undefined)
            {
                delete  state[productId]
            }

            return state
        }

        default:
            return state
    }
}


export default cart;